import { useEffect, useState } from 'react';

/** O valor só "assenta" depois de `ms` sem mudar (busca enquanto digita sem uma consulta por tecla). */
export function useValorAtrasado<T>(valor: T, ms = 250): T {
  const [atrasado, setAtrasado] = useState(valor);
  useEffect(() => {
    const t = setTimeout(() => {
      setAtrasado(valor);
    }, ms);
    return () => {
      clearTimeout(t);
    };
  }, [valor, ms]);
  return atrasado;
}
